import { TransactionReceiptNotFoundError } from '../../errors/transaction.js';
import { format } from '../../utils/formatters/format.js';
import { formatTransactionReceipt, } from '../../utils/formatters/transactionReceipt.js';
export async function getTransactionReceipt(client, { hash }) {
    const receipt = await client.request({
        method: 'eth_getTransactionReceipt',
        params: [hash],
    });
    if (!receipt)
        throw new TransactionReceiptNotFoundError({ hash });
    return format(receipt, {
        formatter: client.chain?.formatters?.transactionReceipt || formatTransactionReceipt,
    });
}
//# sourceMappingURL=getTransactionReceipt.js.map